import React from "react";
import { Input } from "components/Input";
import { Body, Header } from "components/Table/style";
import { Table } from "../../style";

export function PerformanceEnhancer(props) {
  return (
    <Table>
      <Header>
        <tr>
          <th>
            <span></span>
          </th>
          <th>
            <span>Qual Produto?</span>
          </th>
          <th>
            <span>Qual PPM?</span>
          </th>
        </tr>
      </Header>
      <Body>
        <tr>
          <td>Pré</td>
          <td>
            <Input
              type="inputOnly"
              params="health.performanceEnhancer.pre.product"
              item={props.megg}
              setItem={props.setMegg}
              placeholder="Digite o Produto"
            />
          </td>

          <td>
            <Input
              type="inputOnly"
              params="health.performanceEnhancer.pre.dose"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
        </tr>
        <tr>
          <td>Inicial</td>
          <td>
            <Input
              type="inputOnly"
              params="health.performanceEnhancer.initial.product"
              item={props.megg}
              setItem={props.setMegg}
              placeholder="Digite o Produto"
            />
          </td>

          <td>
            <Input
              type="inputOnly"
              params="health.performanceEnhancer.initial.dose"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
        </tr>
        <tr>
          <td>Crescimento</td>
          <td>
            <Input
              type="inputOnly"
              params="health.performanceEnhancer.growth.product"
              item={props.megg}
              setItem={props.setMegg}
              placeholder="Digite o Produto"
            />
          </td>

          <td>
            <Input
              type="inputOnly"
              params="health.performanceEnhancer.growth.dose"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
        </tr>
        <tr>
          <td>Desenvolvimento</td>
          <td>
            <Input
              type="inputOnly"
              params="health.performanceEnhancer.development.product"
              item={props.megg}
              setItem={props.setMegg}
              placeholder="Digite o Produto"
            />
          </td>

          <td>
            <Input
              type="inputOnly"
              params="health.performanceEnhancer.development.dose"
              item={props.megg}
              setItem={props.setMegg}
            />
          </td>
        </tr>
      </Body>
    </Table>
  );
}
